import React, { Fragment } from "react";
import { IS_PROD } from "@data/GlobalData.js";
import { CFW_REFRESHER } from "@genericComponents/CFW.js";
import { GetSession, SetSession } from "@genericComponents/SFW.js";
const CommonDebouncer = await import("@asyncImports/CommonDebouncer.js").then(
  (mod) => mod.CommonDebouncer,
);
class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, error: null, errorInfo: null };
  }

  static getDerivedStateFromError(error) {
    return { hasError: true, error };
  }

  componentDidCatch(error, errorInfo) {
    console.error("Caught error:", error, errorInfo);
    if (
      typeof window !== "undefined" &&
      !GetSession(CFW_REFRESHER) &&
      IS_PROD
    ) {
      CommonDebouncer(
        CFW_REFRESHER,
        () => {
          SetSession(CFW_REFRESHER, "1");
          window.location.reload();
        },
        3000,
      );
    }
    this.setState({ errorInfo });
  }
  render() {
    if (this.state?.hasError) {
      return <Fragment />;
    }
    return this.props.children;
  }
}

export default ErrorBoundary;
